import {ACTION_TYPE} from "utils/constants";

export const updateVersionInfo = info => ({
  type: ACTION_TYPE.UPDATE_VERSION_INFO,
  payload: info,
});
